import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  toString3dhdjl9yf50de as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source) {
        super();
        this.t2x_1 = source;
      }
      a2x() {
        return this.t2x_1;
      }
      b2x(position) {
        return position < this.a2x().length ? position : -1;
      }
      q2t() {
        var source = this.a2x();
        var cpos = this.c2n_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.c2n_1 = cpos;
          return charToTokenClass(c);
        }
        this.c2n_1 = source.length;
        return 10;
      }
      m2t() {
        var current = this.c2n_1;
        if (current === -1)
          return false;
        var source = this.a2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.c2n_1 = current;
          return this.e2x(c);
        }
        this.c2n_1 = current;
        return false;
      }
      d2x() {
        var current = this.c2n_1;
        if (current === -1)
          return current;
        var source = this.a2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.c2n_1 = current;
        return current;
      }
      w2t(expected) {
        if (this.c2n_1 === -1) {
          this.f2x(expected);
        }
        var source = this.a2x();
        var cpos = this.c2n_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.c2n_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.f2x(expected);
        }
        this.c2n_1 = -1;
        this.f2x(expected);
      }
      c2u() {
        this.w2t(_Char___init__impl__6a9atx(34));
        var current = this.c2n_1;
        var closingQuote = indexOf(this.a2x(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.o2t();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false ? this.c2n_1 - 1 | 0 : this.c2n_1;
          var s = this.c2n_1 === charSequenceLength(this.a2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.a2x(), position));
          var tmp$ret$0 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.y2r(tmp$ret$0, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.a2x(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.a2x(), this.c2n_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.c2n_1 = closingQuote + 1 | 0;
        return substring(this.a2x(), current, closingQuote);
      }
      e2u(keyToMatch, isLenient) {
        var positionSnapshot = this.c2n_1;
        try {
          if (!(this.q2t() === 6))
            return null;
          var firstKey = this.z2t(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.g2x();
          if (!(this.q2t() === 5))
            return null;
          return this.z2t(isLenient);
        }finally {
          this.c2n_1 = positionSnapshot;
          this.g2x();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.p2m_1.p2o_1 ? new (StringJsonLexer())(source) : new (StringJsonLexerWithComments())(source);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
